var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isShowMain)?_c('div',{staticStyle:{"margin":"0","padding":"0","width":"100%","height":"100%"}},[_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }